import { SilentRefresh } from "./SilentRefresh";

export default SilentRefresh;
